(ns motorsaif.shared.image-uploader
  (:require
   ;; ["blueimp-canvas-to-blob" :as to-blob]
   [cljs.reader :as reader]
   [promesa.core :as p]
   [clojure.core.async :as async :refer [<! >! chan go go-loop]]
   [motorsaif.log :as log]
   [clojure.edn :as edn]
   [re-frame.core :as rf :refer [dispatch]]
   [reagent.core :as r]))

(def ^:private all-chan (chan))
(def ^:private ec-chan (chan 3)) ;; concurrent uploads

;; Starts conveyor belt that can upload up to 3 images at a time
(go-loop []
  (>! ec-chan ((<! all-chan)))
  (recur))

(defn remove-from-chan []
  (go (<! ec-chan)))

(defn append-fn [afn]
  (go (>! all-chan afn)))

(defn ajax-upload [this form-data]
  (let [{:keys [*response *state on-error *progress on-success]} this]
    (reset! *state :uploading)
    (rf/dispatch [:upload-image
                  {:form-data form-data
                   :progress-handler
                   (fn [e]
                     (let [loaded (.-loaded e)
                           total (.-total e)]
                       (reset! *progress (/ loaded total))))
                   :handler
                   (fn [{:keys [success media] :as res}]
                     (reset! *response media)
                     (reset! *state :success)
                     (on-success media))
                   :error-handler (fn [res]
                                    (reset! *state :error)
                                    (reset! *response :res)
                                    (log/info [:error res])
                                    (when on-error
                                      (on-error
                                       {:image-rec this
                                        :response res})))
                   :finally (fn []
                              (remove-from-chan))}])))

(defprotocol IImageUpload
  (prepare-form-data [this])
  (upload [this]))

(defrecord ImageUpload [uuid ;; unique id
                        file ;; the js file
                        *response ;; response from server
                        orientation ;; from exif
                        opts ;; img opts
                        retry-count ;; for failed/timeout uploads
                        size ;; file size
                        name ;; original file name
                        preview ;; data-url or file name

                        *progress ;; upload progress percentage r/atom
                        *state ;; #{:new, :fail, :succeed}

                        upload-fn]

  IImageUpload
  (prepare-form-data [this] (log/error "Must implement method"))
  (upload [this]
    (p/let [form-data (prepare-form-data this)]
      (ajax-upload this form-data)))

  Object
  (toString [_]
    (str {:state @*state
          :name name
          :file file
          :response @*response
          :orientation orientation
          :size size
          :uuid uuid})))

;; NOTE: This was done for serialization
;; Define a print-method for the ImageUpload record type
;; For some reason I can't just put this within the defrecord
(extend-type ImageUpload
  IPrintWithWriter
  (-pr-writer [{:keys [uuid *state preview *response *progress retry_count orientation size name]}
               writer _]
    (let [data {:uuid uuid
                :state @*state
                :preview preview
                :response @*response
                :progress @*progress
                ;; :preview (:preview image-upload)
                :retry-count retry_count
                :orientation orientation
                :size size
                :name name}]
      (-write writer (str "#motorsaif/ImageUpload " (pr-str data))))))

(defn image-upload-reader [data]
  (let [{:keys [uuid status response data-url opts state
                preview
                retry-count progress size name orientation]} data]
    (map->ImageUpload
     {:uuid uuid
      :*state (r/atom state)
      :opts opts
      :*response (r/atom response)
      :preview preview
      :data-url data-url
      :retry-count retry-count
      :*progress (r/atom progress)
      :size size
      :name name
      :orientation orientation})))

(reader/register-tag-parser! 'motorsaif/ImageUpload image-upload-reader)
